import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfGroupLimitResponse, GroupLimitResponse, GroupLimits, GroupLimitDTO } from "./walletapi";

export const groupLimits = writable<GroupLimitResponse[]>([]);

export async function RefreshGroupLimits() {
    try {
        let response: ApiResultOfListOfGroupLimitResponse = await service.walletapi.groupLimitList({
            Token: sessionStorage.token,
        });


        if (response.Success && response.Data) {
            // Procesar y convertir los datos para asegurar tipos correctos
            const processedGroupLimits: GroupLimitResponse[] = response.Data.map(groupLimit => ({
                ...groupLimit,
                Id: Number(groupLimit.Id),
                GroupId: groupLimit.GroupId !== null && groupLimit.GroupId !== undefined ? Number(groupLimit.GroupId) : undefined,
                UserId: groupLimit.UserId !== null && groupLimit.UserId !== undefined ? Number(groupLimit.UserId) : undefined
            }));

            groupLimits.set(processedGroupLimits);
            
        }
    } catch (error) {
    }
}

export function GroupLimitAdded(groupLimit: GroupLimits)
{   
    // Convertir GroupLimits a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        list.unshift(groupLimitResponse);
        return list;
    });
};

export function GroupLimitEdited(groupLimit: GroupLimits)
{   
    // Convertir GroupLimits a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        const index = list.findIndex(gl => gl.Id === groupLimit.Id);
        if (index !== -1) {
            // Actualizar el elemento existente
            list[index] = groupLimitResponse;
        } else {
            // Si no se encuentra, agregarlo al inicio
            list.unshift(groupLimitResponse);
        }
        return list;
    });
};

export function GroupLimitChanged(groupLimit: GroupLimitDTO)
{   
    // Convertir GroupLimitDTO a GroupLimitResponse para compatibilidad con el store
    const groupLimitResponse: GroupLimitResponse = {
        Id: groupLimit.Id,
        GroupId: groupLimit.GroupId,
        UserId: groupLimit.UserId,
        InitialBalance: groupLimit.InitialBalance,
        Balance: groupLimit.Balance,
        DateTransaction: groupLimit.DateTransaction,
        Active: groupLimit.Active
    };

    groupLimits.update(list => {
        const index = list.findIndex(gl => gl.Id === groupLimit.Id);
        if (index !== -1) {
            // Actualizar solo el estado Active
            list[index] = {
                ...list[index],
                Active: groupLimit.Active
            };
        }
        return list;
    });
};
